import { Auth } from "aws-amplify";
import { call, put, takeLatest } from "redux-saga/effects";
import UserClient from "services/api/users";

import * as userActions from "state/modules/user/actions";

import { AxiosResponse } from "axios";
import { UserActionTypes } from "./types";

export function* handleGetUser(): Generator {
	try {
		let userRes = (yield call(
			UserClient.getMyProfile,
		)) as AxiosResponse;

		if (!userRes.data.content) {
			const currentUserInfo: any = yield call([Auth, "currentUserInfo"]);
			yield call(
				UserClient.linkMyEmail,
				currentUserInfo.attributes.email
			);

			userRes = (yield call(
				UserClient.getMyProfile,
			)) as AxiosResponse;
		}

		yield put(userActions.setUser(userRes.data.content));
	} catch (error) {
		console.log({ error });
	}
}

export function* userSaga(): Generator {
	yield takeLatest(UserActionTypes.GET_USER, handleGetUser);
}
